// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610121905/js/" + chunkId + "." + {"44":"61fa17b7","225":"bedd0e2a","481":"bd969f83","486":"f1f53925","770":"7cbbe58f"}[chunkId] + ".0.37570624431125366.chunk.js";
};